import { render, staticRenderFns } from "./AppIconArrowDropup.vue?vue&type=template&id=ea4668dc&scoped=true&"
import script from "./AppIconArrowDropup.vue?vue&type=script&lang=js&"
export * from "./AppIconArrowDropup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4668dc",
  null
  
)

export default component.exports